module.exports = __webpack_public_path__ + "static/media/educationCat.668f6dee.jpg";